export default __webpack_public_path__ + "static/media/f1.7268eb05.png";